var prop = require('./prop')

function id (e) { return e }

module.exports = function tester (test) {
  return (
    'object' === typeof test && 'function' === typeof test.test //regexp
    ? function (data) { return test.test(data) }
    : prop (test) || id
  )
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/pull-stream/util/tester.js
// module id = 329
// module chunks = 0